(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };

  // drawer menu
  var menu = $('#menu'), scrim = $('#mscrim'), btn = $('#mbtn');
  function setMenu(v) {
    if (!menu) return;
    menu.classList.toggle('open', v);
    menu.setAttribute('aria-hidden', String(!v));
    scrim.hidden = !v;
    if (btn) btn.setAttribute('aria-expanded', String(v));
  }
  if (btn) btn.addEventListener('click', function () { setMenu(true); });
  var mc = $('#mclose');
  if (mc) mc.addEventListener('click', function () { setMenu(false); });
  if (scrim) scrim.addEventListener('click', function () { setMenu(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });

  // 3D parallax for every .stage (hero and set preview)
  if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var clamp = function (v) { return Math.max(-1, Math.min(1, v)); };
    document.querySelectorAll('.stage').forEach(function (st) {
      var area = st.closest('.hero-home, .preview') || st;
      var tx = 0, ty = 0, cx = 0, cy = 0, run = false;
      var loop = function () {
        cx += (tx - cx) * 0.12; cy += (ty - cy) * 0.12;
        st.style.setProperty('--px', cx.toFixed(3)); st.style.setProperty('--py', cy.toFixed(3));
        if (Math.abs(tx - cx) + Math.abs(ty - cy) > 0.002) requestAnimationFrame(loop); else run = false;
      };
      var go = function () { if (!run) { run = true; requestAnimationFrame(loop); } };
      area.addEventListener('pointermove', function (e) {
        var r = area.getBoundingClientRect();
        tx = clamp(((e.clientX - r.left) / r.width - 0.5) * 2);
        ty = clamp(((e.clientY - r.top) / r.height - 0.5) * 2);
        go();
      });
      area.addEventListener('pointerleave', function () { tx = ty = 0; go(); });
      addEventListener('deviceorientation', function (e) {
        if (e.gamma == null) return;
        tx = clamp(e.gamma / 25); ty = clamp((e.beta - 45) / 25); go();
      });
    });
  }

  // datum "za kada treba toper" + hitna narudžba (svi proizvodi)
  var dat = $('#set-dat');
  if (dat) {
    dat.min = new Date().toISOString().slice(0, 10);
    var hint = $('#set-hint'), box = $('#hitna'), cb = $('#hitna-cb'), warn = $('#hitna-warn');
    var MIN_DAYS = 10;
    dat.addEventListener('change', function () {
      if (!dat.value) return;
      var d = new Date(), end = new Date(dat.value + 'T00:00:00'), n = 0;
      d.setHours(0, 0, 0, 0);
      while (d < end) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n++; }
      if (n < MIN_DAYS) {
        hint.textContent = 'Do tog datuma ima samo ' + n + ' radnih dana, a izrada i dostava traju 10–12.';
        if (box) { box.hidden = false; if (warn) warn.hidden = n >= 4; }
        else hint.textContent += ' Javi nam se za hitnu narudžbu.';
      } else {
        hint.textContent = 'Do tog datuma ima ' + n + ' radnih dana, dovoljno za izradu.';
        if (box) { box.hidden = true; if (cb) cb.checked = false; }
      }
    });
  }

  // ime za bočno postavljanje (+6 €): kutija otvara polje za ime
  var icb = $('#ime-cb'), ifield = $('#ime-field'), iinput = $('#ime-input');
  if (icb && ifield) {
    icb.addEventListener('change', function () {
      ifield.hidden = !icb.checked;
      if (iinput) { iinput.required = icb.checked; if (icb.checked) iinput.focus(); }
    });
  }

  // dodatne stavke uz toper (hitna narudžba, ime): dodaju se u košaricu zajedno s toperom
  var form = $('form.pform'), cb2 = $('#hitna-cb'), box2 = $('#hitna');
  if (form && (cb2 || icb)) {
    form.addEventListener('submit', function (e) {
      var wantHitna = !!(cb2 && box2 && cb2.checked && !box2.hidden);
      var wantIme = !!(icb && icb.checked);
      if (!wantHitna && !wantIme) return;
      if (wantIme && (!iinput || !iinput.value.trim())) {
        e.preventDefault();
        if (iinput) iinput.focus();
        return;
      }
      e.preventDefault();
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var fd = new FormData(form), props = {};
      fd.forEach(function (v, k) {
        var m = k.match(/^properties\[(.+)\]$/);
        if (m && v !== '') props[m[1]] = v;
      });
      var items = [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity')) || 1, properties: props }];
      fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
        if (wantHitna) {
          var has = c.items.some(function (i) { return String(i.variant_id) === cb2.dataset.variant; });
          if (!has) items.push({ id: Number(cb2.dataset.variant), quantity: 1 });
        }
        if (wantIme) {
          items.push({ id: Number(icb.dataset.variant), quantity: 1, properties: { 'Ime na torti': iinput.value.trim() } });
        }
        return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        location.href = root + 'cart';
      }).catch(function () {
        if (cb2) cb2.checked = false;
        if (icb) icb.checked = false;
        form.submit();
      });
    });
  }
})();
